export type ClientKind = "browser" | "headless" | "script";

export const SCRAPER_NOTE = "we know what you are doing :) reach out if you'd like direct api access - colin@upside.tools";

const HEADLESS = /headless|puppeteer|playwright|selenium/i;
const BROWSER = /^Mozilla\/5\.0 \(/;

export function classifyClient(userAgent: string | null): ClientKind {
  const ua = userAgent ?? "";
  if (HEADLESS.test(ua)) return "headless";
  return BROWSER.test(ua) ? "browser" : "script";
}
